import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutExternal20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowOutExternal20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.75 3a.75.75 0 0 0 0 1.5h2.69L9.47 9.47a.75.75 0 1 0 1.06 1.06l4.97-4.97v2.69a.75.75 0 0 0 1.5 0V3zM3 6.75A2.75 2.75 0 0 1 5.75 4H8a.75.75 0 0 1 0 1.5H5.75c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25V12a.75.75 0 0 1 1.5 0v2.25A2.75 2.75 0 0 1 13.25 17h-7.5A2.75 2.75 0 0 1 3 14.25z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutExternal20);
